const model = {
    submitting: false,
    errors: null,
    partnerDetails: null,
    success: false,
    partnerType: [],
};

export default model;
